import { useCallback, useEffect, useState } from "react";
import { deleteData, fetchData, getAccessToken, putData } from "../common/MSALHelper";
import { useMsal } from "@azure/msal-react";
import { useParams } from "react-router-dom";
import AddContribution from "./AddContribution";
import DateTimeInput from "../common/DateTimeInput";

export default function ContributionList({ refresh_receipt_list }) {
    const { instance, accounts } = useMsal();
    const { member_id } = useParams();
    const [ contributionList, setContributionList ] = useState([]);
    const [ showContributionView, setShowContributionView ] = useState(false)

    const getDisplayData = () => {
        if (contributionList) {
            if (Array.isArray(contributionList)) {
                const filteredData = contributionList; //data.filter(item => !filterValue || (item["chiHoi"] && item["chiHoi"].toLowerCase().includes(filterValue.toLowerCase())));
                return <table>
                    <thead>
                        <tr>
                            <th>Contribution ID</th>
                            <th>Parishioner ID</th>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>Mark</th>
                            <th>Has Receipt</th>
                            <th>Old Receipt No.</th>
                            <th>Receipt No.</th>
                            <th>Note</th>
                            <th>Have Sent Thank You Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((value) =>
                        (
                            <ContributionListItem key={value.ID} contribution={value} refreshData={() => {refresh(); refresh_receipt_list();}} />
                        )
                        )
                        }
                    </tbody>
                </table>
            }
            else
                return <div>No data</div>;
        }
        else
            return <div>Loading</div>
    };

    const displayAddContribution = () => {
        if (showContributionView)
            return <AddContribution member_id={member_id} hideAddContribution={hideAddContribution} refreshData={refresh} />
        else
            return <></>
    }

    const hideAddContribution = () => {
        setShowContributionView(false);
    }

    const refresh = () => {
        callFetchData();
    }

    const callFetchData = useCallback(async () => {
        try {
            getAccessToken(instance, accounts).then(response => {
                let accessToken = response;
                fetchData(accessToken, `/users/${member_id}/contributions`, fetch_response => {
                    if (fetch_response.ok)
                        return fetch_response.json();
                    else {
                        console.error('Failed to fetch parishioner data');
                    }
                }, data => {
                    console.log(data);
                    let dataArray = data;
                    setContributionList(dataArray);
                    // setFormData({
                    //     ...parishionerData,
                    //     // Convert dates to a format suitable for date input
                    //     hndoG_PLTT_Date: parishionerData.hndoG_PLTT_Date ? new Date(parishionerData.hndoG_PLTT_Date).toISOString().split('T')[0] : '',
                    //     ngayQuaDoi: parishionerData.ngayQuaDoi ? new Date(parishionerData.ngayQuaDoi).toISOString().split('T')[0] : '',
                    //     ngayQuaDoiSecondary: parishionerData.ngayQuaDoiSecondary ? new Date(parishionerData.ngayQuaDoiSecondary).toISOString().split('T')[0] : '',
                    //     registrationDate: parishionerData.registrationDate ? new Date(parishionerData.registrationDate).toISOString().split('T')[0] : ''
                    // });
                });
            });
        } catch (error) {
            console.error('Error fetching parishioner data:', error);
        }
    }, [instance, accounts, member_id, setContributionList]);

    useEffect(() => {
        callFetchData();
        // console.log(member_id);
    }, [member_id, callFetchData]);
    return <div>
        <div><button onClick={() => { setShowContributionView(!showContributionView) }}>Add Contribution</button></div>
        {displayAddContribution()}
        <div>
            {getDisplayData()}
        </div>
    </div>;
}

export function ContributionListItem({contribution, refreshData}) {
    const { instance, accounts } = useMsal();
    const [editing, setEditing] = useState(false);
    const [formData, setFormData] = useState({
        ...contribution
    });

    const showButtons = () => {
        if (editing) {
            return <>
                <button onClick={() => {
                    submit_click();
                }}>Submit</button>
                <button onClick={(event) => {
                    event.preventDefault();
                    cancel_click();
                }}>Cancel</button>
            </>;
        }
        else {
            return <>
            <button onClick={() => {
                edit_click();
            }}>Edit</button>
            <button onClick={() => {
                delete_click();
            }}>Delete</button>
            </>;
        }
    }

    const edit_click = (event) => {
        setEditing(true);
    }

    const delete_click = async (event) => {
        // Call API to delete
        try {
            getAccessToken(instance, accounts).then(response => {
                let accessToken = response;
                deleteData(accessToken, `/contribution/${contribution.ID}`, fetch_response => {
                    if (fetch_response.ok) {
                        // Contribution deleted successfully
                        console.log('Contribution deleted successfully');
                        refreshData();
                        setEditing(false);
                    }
                    else {
                        // Handle error response
                        console.error('Failed to delete Contribution');
                    }
                }, data => {
                    console.log(data);
                });
            });
        }
        catch (error) {
            // Handle fetch error
            console.error('Error deleting Contribution:', error);
        }
    }

    const cancel_click = (event) => {
        setFormData({ ...contribution });
        setEditing(false);
    }

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        let newValue = value;

        if (name === 'Amount') {
            // Validate amount to allow only numbers with optional decimal point
            newValue = value.replace(/[^0-9.]/g, ''); // Allow only digits and dot
            const decimalCount = (value.match(/\./g) || []).length;
            if (decimalCount > 1 ) {
                // Allow only one decimal point
                newValue = formData.Amount;
            }
        } else {
            newValue = type === 'checkbox' ? checked : value;
        }
        setFormData({ ...formData, [name]: newValue });
    }

    const submit_click = async (event) => {
        //Call API to update
        try {
            getAccessToken(instance, accounts).then(response => {
                let accessToken = response;
                putData(accessToken, `/contribution/${contribution.ID}`, fetch_response => {
                    if (fetch_response.ok) {
                        // Contribution updated successfully
                        console.log('Contribution updated successfully');
                        refreshData();
                        setEditing(false);
                    }
                    else {
                        // Handle error response
                        console.error('Failed to update Contribution');
                    }
                }, data => {
                    // console.log(data);
                }, JSON.stringify({
                    ...formData,
                }));
            });
        } catch (error) {
            // Handle fetch error
            console.error('Error updating Contribution:', error);
        }
    }

    return (
        <tr key={contribution.ID}>
            <td>{contribution.ID}</td>
            <td>{contribution.ParishionerID}</td>
            <td>{editing ? (<input type="text" name={"Amount"} value={formData["Amount"]} onChange={handleChange} />) : contribution.Amount}</td>
            <td>{editing ? (<DateTimeInput apiDate={formData["Date"]} onChange={(newDateTime) => { setFormData({ ...formData, Date: newDateTime }); }} />) : contribution.Date}</td>
            <td>{editing ? (<input type="checkbox" name={"Mark"} checked={formData.Mark} onChange={handleChange} />): (contribution.Mark ? 'Yes' : 'No')}</td>
            <td>{editing ? (<input type="checkbox" name={"Receipt"} checked={formData.Receipt} onChange={handleChange} />): (contribution.Receipt ? 'Yes' : 'No')}</td>
            <td>{editing ? (<input type="text" name={"ReceiptNo_Old"} value={formData["ReceiptNo_Old"]} onChange={handleChange} />) : (contribution.ReceiptNo_Old==0 ? '' : contribution.ReceiptNo_Old)}</td>
            <td>{editing ? (<input type="text" name={"ReceiptNo"} value={formData["ReceiptNo"]} onChange={handleChange} />) : (contribution.ReceiptNo==0 ? '' : contribution.ReceiptNo)}</td>
            <td>{editing ? (<input type="text" name={"Note"} value={formData["Note"]} onChange={handleChange} />) : contribution.Note}</td>
            <td>{editing ? (<input type="checkbox" name={"ThankYouNoteSent"} checked={formData.ThankYouNoteSent} onChange={handleChange} />) : (contribution.ThankYouNoteSent ? 'Yes' : 'No')}</td>
            <td>{showButtons()}</td>
        </tr>
    )
}
